import apiClient from "../services/apiClient";

export const getPlayersByTeam = async (teamId) => {
  try {
    const response = await apiClient.get(`/api/players/${teamId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch players:", error);
    throw error;
  }
};

export const addPlayer = async (playerData) => {
  try {
    const response = await apiClient.post(`/api/players/create`, playerData);
    return response.data;
  } catch (error) {
    console.error("Failed to add player:", error);
    throw error;
  }
};

export const deletePlayer = async (id) => {
  try {
    await apiClient.delete(`/api/players/${id}`);
  } catch (error) {
    console.error("Failed to delete player:", error);
    throw error;
  }
};
